import { useTranslation } from 'next-i18next';
import { GradientTypography } from '../StyledComponents';
import {
  Box,
  Grid,
  Typography,
  IconButton,
  Divider,
  Link,
} from '@mui/material';
import { Globe } from 'lucide-react';
import { FaXTwitter } from 'react-icons/fa6';
import { SiDiscord } from 'react-icons/si';
import TelegramIcon from '@mui/icons-material/Telegram';
import BoxLayout from '@/components/pages/box/layout/BoxLayout';

export default function Footer() {
  const { t } = useTranslation();

  // Navigation links
  const navLinks = {
    [t('footer.products')]: [
      { name: 'Fomo Power', href: '/games/fomo/zones' },
      // { name: 'Crypto Battle', href: '#' },
      // { name: 'NFT Worlds', href: '#' },
    ],
    [t('footer.community')]: [
      { name: 'Discord', href: 'https://discord.gg/5DzrNzmefA' },
      { name: 'Telegram', href: 'https://t.me/wowspacefun' },
      { name: 'Twitter', href: 'https://twitter.com/wowspacefun' },
    ],
    // Resources: [
    //     { name: 'Documentation', href: '#' },
    //     { name: 'Whitepaper', href: '#' },
    //     { name: 'Blog', href: '#' },
    // ],
    // Legal: [
    //     { name: 'Terms of Service', href: '#' },
    //     { name: 'Privacy Policy', href: '#' },
    // ],
  };

  return (
    <Box
      component="footer"
      sx={{
        py: 6,
        color: '#B0B0B0',
      }}
    >
      <Box
        sx={{
          width: 'auto',
          margin: '0 16px',
          '@media (min-width: 1500px)': {
            width: '1200px',
            margin: '0 auto',
          },
        }}
      >
        <Grid container spacing={2} sx={{ mb: 4 }}>
          {/* Logo and Slogan */}
          <Grid item xs={12} md={4}>
            <img
              src="/assets/images/logo/Wow_Space_logo_pc.png"
              alt=""
              className="-m-1 md:-m-1 h-12 md:h-12 w-auto"
            />
            <Typography
              variant="body2"
              color="#B0B0B0"
              sx={{ maxWidth: 250, mb: { xs: 2, md: 3 }, mt: 1 }}
            >
              {t('footer.tagline')}
            </Typography>

            {/* Social Icons for both Mobile and Desktop */}
            <Box sx={{ display: 'flex', gap: 2 }}>
              <IconButton
                size="small"
                sx={{
                  color: '#FFFFFF',
                  '&:hover': { color: '#A56CFF' },
                }}
                href="https://twitter.com/wowspacefun"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaXTwitter size={20} />
              </IconButton>
              <IconButton
                size="small"
                sx={{
                  color: '#FFFFFF',
                  '&:hover': { color: '#A56CFF' },
                }}
                href="https://discord.gg/5DzrNzmefA"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SiDiscord size={20} />
              </IconButton>
              <IconButton
                size="small"
                sx={{
                  color: '#FFFFFF',
                  '&:hover': { color: '#A56CFF' },
                }}
                href="https://t.me/wowspacefun"
                target="_blank"
                rel="noopener noreferrer"
              >
                <TelegramIcon fontSize="small" />
              </IconButton>
              <IconButton
                size="small"
                sx={{
                  color: '#FFFFFF',
                  '&:hover': { color: '#A56CFF' },
                }}
                href="#"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Globe size={20} />
              </IconButton>
            </Box>
          </Grid>

          {/* Navigation Links */}
          {Object.entries(navLinks).map(([category, links]) => (
            <Grid item xs={6} md={3} key={category}>
              <Typography
                variant="subtitle1"
                color="#FFFFFF"
                fontWeight="bold"
                mb={2}
              >
                {category}
              </Typography>
              <Box component="ul" sx={{ p: 0, m: 0, listStyle: 'none' }}>
                {links.map((link) => (
                  <Box component="li" key={link.name} sx={{ mb: 1 }}>
                    <Link
                      href={link.href}
                      underline="hover"
                      sx={{
                        color: '#B0B0B0',
                        fontSize: '0.875rem',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          color: '#FFFFFF',
                          textShadow: '0 0 8px rgba(165, 108, 255, 0.5)',
                        },
                      }}
                    >
                      {link.name}
                    </Link>
                  </Box>
                ))}
              </Box>
            </Grid>
          ))}

          <Grid item xs={0} md={2}></Grid>
        </Grid>

        <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.1)', my: 3 }} />
        <Typography variant="body2" color="#B0B0B0" textAlign="center">
          © 2025 WoW.Space. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
}
